import { render } from "./Downloads.vue?vue&type=template&id=f654aa8c&scoped=true"
import script from "./Downloads.ts?vue&type=script&lang=js"
export * from "./Downloads.ts?vue&type=script&lang=js"

import "./Downloads.vue?vue&type=style&index=0&id=f654aa8c&lang=scss&scoped=true"

import exportComponent from "/Users/lucatescari/Documents/Projects/Private/rt-songpage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f654aa8c"]])

export default __exports__